import { AdTemplate } from '@/components/AdTemplate';
import { LabradorComponent } from '@/types/component';

export const LabradorAdTemplate: LabradorComponent = ({ data }) => {
  return <AdTemplate pageMeta={data?.meta} />;
};
